import { render } from "./RespaldosNube.vue?vue&type=template&id=d15ef22e"
import script from "./RespaldosNube.vue?vue&type=script&lang=js"
export * from "./RespaldosNube.vue?vue&type=script&lang=js"
script.render = render

export default script